export default __webpack_public_path__ + "static/media/banking-outline-16px.1fb717f1.svg";